import { z } from 'zod';
import { msg } from '@/lib/forms/messages';

// Module-level const, not a `createSchema(t)` factory: msg() resolves at parse time.

// Mirror: application/drbfm/workflow_service.py:587-593 runs _require_review_text (:849-854,
// which trims) on accept/modify. That helper also guards item_name and category, but this card
// edits neither, so only change_description is mirrored. No cap: the column is TEXT, no CHECK.
export const designChangeReviewSchema = z.object({
  changeDescription: z.string().trim().min(1, msg('validation.required')),
});
